import { render } from "./state-layer.vue?vue&type=template&id=1be02ec4&scoped=true"
const script = {}

import "./state-layer.vue?vue&type=style&index=0&id=1be02ec4&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be02ec4"]])

export default __exports__